import React from 'react';
import ReactDOM from 'react-dom';
import AppRoot from './shared/AppRoot';
import Base from "./components/Base";

export function init () {
    if (document.getElementById('offersContainer')) {
        ReactDOM.render(
            <AppRoot>
                <Base />
            </AppRoot>,
            document.getElementById('offersContainer')
        );
    }
}